import TableContainer from "Common/TableContainer";
import { useAssignmentSpecialPermissionList } from "../../hooks";
import { ModalAssigmentSpecialPermission } from "../../components";
import { useTranslation } from "react-i18next";
import BreadCrumb from "Common/BreadCrumb";
import { SelectSessionValidation } from "Common/Components";

export const AssignmentSpecialPermissionList = () => {
  const { columns, DataAssigment, session, setCompany } =
    useAssignmentSpecialPermissionList();
  const { t } = useTranslation();

  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb
          title={t("AssigmentSpecialPermission.titleListPage")}
          pageTitle={t("menu.assigmentSpecialPermissions")}
        />
        <div className="card">
          <div className="card-body">
            <div className="flex w-full items-center justify-between flex-wrap">
              <SelectSessionValidation
                classname="w-1/2"
                valueCompanie={
                  session?.employe != null
                    ? session?.employe.branch.company.id.toString()
                    : ""
                }
                onChangeCompanie={(option) => {
                  if (option.value === undefined) return;

                  setCompany(option.value);
                }}
                onChangeBranch={() => {}}
                hideBranch={true}
              />
              <div className="mt-4"></div>
            </div>
            <div className="w-full pt-6">
              <TableContainer
                isPagination={true}
                columns={columns || []}
                data={DataAssigment || []}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
                theadclassName="border-b border-slate-200 dark:border-zink-500"
                thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
                tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              ></TableContainer>
            </div>
            <ModalAssigmentSpecialPermission />
          </div>
        </div>
      </div>
    </>
  );
};
